export default __webpack_public_path__ + "3bc1dbc7d105d3e66658a1b34e1d0749.jpg";